import React, { useState, useEffect, useContext, useMemo } from "react";
import Accordion from "../../common/accordion";
import { useParams } from "react-router-dom";
import axios from "axios";
import { TabTitle } from "../../common/dynamicTitle";
import Breadcrumbs from "../../common/breadcumb";
import { Link } from "react-router-dom";
import "./index.scss";
import { LangContext } from "../../context/LangContext";
function Careers() {
  const { state } = useContext(LangContext);
  const nep = state.np;
  const { slug } = useParams(null);
  const pageTitle = useMemo(() => (nep ? "क्यारियर" : "Careers"), [nep]);
  TabTitle(`GMBF | ${pageTitle}`);
  const [careers, setCareers] = React.useState();
  const APIURL = `${process.env.REACT_APP_URL}career/all`;
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(false);
  React.useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        setError(false);
        const response = await axios.get(APIURL);
        setCareers(response.data.items.en);
        // console.log(response.data.items.en);
        setLoading(false);
      } catch (error) {
        setError(true);
        setLoading(false);
      }
    })();
  }, [slug]);
  if (loading) return "";
  if (error) return "Error";
  return (
    <>
      <Breadcrumbs PageTitle={pageTitle} />
      <main className="InsidePageContainer">
        <div className="faq-box">
          <div className="wrapper">
            <div className="career-container">
              {careers.length === 0
                ? nep
                  ? "हाल, यहाँ कुनै पनि पद खाली छैन।"
                  : "Currently, there is no vacancy here."
                : careers.map((career, index) => {
                    return (
                      <>
                        <div className="CarrersBox" key={index}>
                          <div className="CareerTitle">
                            <h2>{career.title}</h2>
                            <Link to={career.slug}>
                              <button>
                                {nep ? "आवेदन दिनुहोस्" : "Apply Now"}
                              </button>
                            </Link>
                          </div>
                          <div className="branch">
                            <h3>{nep ? "शाखाहरू" : "Branches"} : </h3>
                            {career.branches?.map((branch, index) => {
                              return (
                                <>
                                  <span key={index}>
                                    {branch.PageTitle} {`,`}
                                  </span>
                                </>
                              );
                            })}
                          </div>
                          <div className="numbers">
                            <h3>
                              {nep ? "खोल्ने संख्या" : "Number of Opening"} :
                              <span>{career.jobNumber}</span>
                            </h3>
                            <h3>
                              {nep ? "आवेदन समय सीमा" : "Application Deadline"}:
                              <span>{career.EndDate}</span>
                            </h3>
                          </div>
                          <div className="description">
                            <div
                              className="CKContentBox"
                              dangerouslySetInnerHTML={{
                                __html: career?.description
                                  ? career?.description
                                  : "",
                              }}
                            ></div>
                          </div>
                        </div>
                      </>
                    );
                  })}
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default Careers;
